<template>
  <v-timeline dense>
    <v-timeline-item
      v-for="item in activity.slice().reverse()"
      :key="item.timestamp"
      right
      small
      :color="getActivityColor(item.activityType)"
    >
      <v-row>
        <v-col cols="auto">
          <strong>{{
            new Date(item.timestamp)
              .toLocaleTimeString()
              .replace(/:[0-9]+$/, "")
          }}</strong>
          <div class="caption">
            {{ new Date(item.timestamp).toLocaleDateString() }}
          </div>
        </v-col>
        <v-col>
          <strong>{{ getActivityTitle(item.activityType) }}</strong>
          <div v-if="item.additionalInformation" class="caption">
            {{ item.additionalInformation }}
          </div>
        </v-col>
      </v-row>
    </v-timeline-item>
    <v-timeline-item right small color="grey">
      <v-row>
        <v-col cols="auto">
          <strong>{{
            new Date(createdAt).toLocaleTimeString().replace(/:[0-9]+$/, "")
          }}</strong>
          <div class="caption">
            {{ new Date(createdAt).toLocaleDateString() }}
          </div>
        </v-col>
        <v-col>
          <strong>{{ $t("orderCreated") }}</strong>
          <div v-if="sourceUrl">{{ sourceUrl }}</div>
        </v-col>
      </v-row>
    </v-timeline-item>
  </v-timeline>
</template>

<script>
export default {
  props: ["createdAt", "activity", "sourceUrl"],
  methods: {
    getActivityColor(activityType) {
      if (activityType === "confirmed" || activityType === "paid")
        return "success";
      else if (activityType === "rejected") return "error";
      return "primary";
    },
    getActivityTitle(activityType) {
      if (activityType === "paid") return this.$t("paymentReceived");
      else if (activityType === "confirmed") return this.$t("orderConfirmed");
      else if (activityType === "rejected") return this.$t("orderRejection");
      else if (activityType === "completed") return this.$t("orderCompleted");
    },
  },
};
</script>